/* eslint-disable no-empty-pattern */
import kitsu from '@plugins/kitsu';
import http from '@plugins/axios';
import { isObject, getDeepObj } from '@/utils/format';
let $ajax;

export const state = {
  pelaksanas: [],
  pelaksana: {},
  cache: {},
};

export const mutations = {
  SET_PELAKSANAS(state, newValue) {
    state.pelaksanas = newValue;
  },
  SET_PELAKSANA(state, newValue) {
    state.pelaksana = newValue;
  },
  SET_CACHE(state, newValue) {
    state.cache = newValue;
  },
};

export const actions = {
  async fetch({ commit }, payload) {
    let result = {};
    const attr = payload.attr || {};

    if (attr.cache && state.cache[attr.endpoint] && !attr.reset) {
      return state.cache[attr.endpoint];
    }

    $ajax = kitsu({ baseURL: process.env.VUE_APP_API_URL + `/psp/gtk/${attr.endpoint}` });
    result = await $ajax.get('/', { params: payload.params });

    if (attr.cache) {
      let cache = {};
      cache[attr.endpoint] = result;
      commit('SET_CACHE', Object.assign({}, state.cache, cache));
    }

    return result;
  },

  async getMasterPic({ state }) {
    const { data } = await http.get(`psp/gtk/pendampingan-ks/pic/${state.pelaksana.psp_pelaksana_id}`);
    return data;
  },

  async getDetail({}, payload) {
    $ajax = kitsu({
      baseURL: process.env.VUE_APP_API_URL + `/psp/gtk/${payload.attr.endpoint}`,
    });
    return await $ajax.get(`/${payload.id}`);
  },

  async getPelaksana({ commit, state }) {
    const pelaksanas = await http.get(`/psp/gtk/pendampingan-ks`).then(({ data }) => data);
    const pelaksanasLaporan = pelaksanas.filter(
      (pelaksana) =>
        pelaksana.psp_kp_pa_sekolah &&
        +pelaksana.psp_kp_pa_sekolah.is_aktif === 1 &&
        +getDeepObj(pelaksana, 'psp_kp_pa_sekolah.psp_kp_pa.gelombang') !== 3
    );

    commit('SET_PELAKSANAS', pelaksanasLaporan);
    if (!isObject(state.pelaksana)) {
      commit('SET_PELAKSANA', pelaksanasLaporan[0] || {});
    }

    return pelaksanas;
  },

  updatePelaksana({ state, commit }, sekolahId) {
    const pspPelaksanas = (state.pelaksanas || []).filter((pelaksana) => +pelaksana.sekolah_id === +sekolahId);

    commit('SET_PELAKSANA', pspPelaksanas[0] || {});
  },

  upload({}, payload) {
    const url = `/psp/gtk/${payload.attr.endpoint}`;
    return http.post(url, payload.params, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  save({}, payload) {
    const url = `/psp/gtk/${payload.endpoint}`;
    return http.post(url, payload.params);
  },

  actions({}, payload) {
    const url = `/psp/gtk/${payload.endpoint}/${payload.id}${payload.action ? `/${payload.action}` : ''}`;
    return http.post(url).then(({ data }) => data);
  },
};
